<ion-content>
  <div class="container modal fade" [style.display]="showImportPopup? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <ion-row>
          <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="10">
            <div class="d-flex">
              <img src="././assets/icon/backArrow.svg" class="cp" (click)="backBtn()">
              <label class="font_medium fs-16 ml-10 mt-5 black_color importContentText">Import</label>
              <label class="font_medium fs-16 ml-10 mt-5 black_color importContentText">{{ importPath }}</label>
            </div>
          </ion-col>
          <ion-col size-sm="2" size-md="3" size-lg="3" size-xs="2" class="text-right">
            <label *ngIf="moduleName == 'importgoals'" class="font_medium fs-16 cp blue importContentText" (click)="importHistory()"><u>Import
              History</u></label>
          </ion-col>
        </ion-row>      
      </div>
      <div class="modal-body" *ngIf="moduleName == 'importemployee'">
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
              <div class="importCardBox">
                <button class="downloadImportFileBtn font_medium mr-30 mt-10" [style.background-color]="buttonColorName " (click)="downloadImportFile()">
                  <img class="mr-10" src="././assets/icon/downloadWhite.svg">Download Import File Template</button>
                <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp"
                  (click)="browseImage.click()">
                  <div class="d-flex text-center">
                    <label class="uploadBtn text_center font_regular cp">Browse File<br>Please select Excel File
                      Only</label>
                    <input #browseImage type="file" (change)="selectFile($event)" style="display:none;">
                  </div>
                </div>
                <div *ngIf="showBrowseBtn">
                  <div class="d-flex mb-50 mt-50">
                    <div class="verticle-center mr-20">
                      <img src="././assets/icon/successImport.svg">
                    </div>
                    <div class="flex-column">
                      <label class="fs-16 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                      <label class="fs-16 font_medium cl-black">{{fileName}}</label>
                    </div>
                  </div>
                  <div class="mb-20">
                    <!-- <button class="cancle-btn font_medium mr-10 mt-10" (click)="onClickCancel()">Cancel</button> -->
                    <button class="Donebtn font_medium mr-30 mt-10" (click)="onClickDone()">Done</button>
                  </div>
                </div>
              </div>
              <div class="clear20"></div>
              <label class="font_medium fs-16 cp blue" (click)="importHistory()"><u>Import
                  History</u></label>
            </ion-col>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
              <div class="font_regular fs-16 ml-10 mt-5 black_color">Note: Please make sure the following mandatory
                fields with data are present in the file (as per sample template available above)</div>
              <ion-row>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                  <ul class="pl-30 font_regular fs-14">
                    <li>Employee Code</li>
                    <li>Employment category</li>
                    <li>Employment Type</li>
                    <li>Date Of Joining</li>
                    <li>Group Name</li>
                    <li>Company Name</li>
                    <li>Official Email</li>
                    <li>ReportingManager Name</li>
                    <li>ReportingManager Code</li>
                    <li>Dotted Reporting Manager Name</li>
                    <li>Dotted Reporting Manager Code</li>
                    <li>HOD</li>
                    <li>HOD Code</li>
                    <li>Band</li>
                    <li>Grade</li>
                    <li>Designation</li>
                    <li>Department/Function</li>
                    <li>Plant Location</li>
                    <li>Group Weekly Off</li>
                    <li>Work Location-State</li>
                    <li>Work Location- City/ Town</li>
                    <li>Designation at DOJ</li>
                    <li>Salutation</li>
                    <li>First Name</li>
                    <li>Last Name</li>
                  </ul>
                </ion-col>
                <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6">
                  <ul class="font_regular fs-14">
                    <li>Gender</li>
                    <li>Country</li>
                    <li>Present Address</li>
                    <li>Date of Birth</li>
                    <li>Age</li>
                    <li>AdharCard No.</li>
                    <li>PAN No.</li>
                    <li>MobileNo (whats app no.)</li>
                    <li>Salary Status</li>
                    <li>Bank Name</li>
                    <li>Bank Branch Address</li>
                    <li>Bank Account No</li>
                    <li>IFSC Code</li>
                     <li>Effective Date</li>
                    <li>Basic Salary PM</li>
                    <li>Gross Salary PM</li>
                    <li>Total Retiral PM</li>
                    <li>Fixed CTC Including Retirals PM</li>
                    <li>Fixed CTC Including Retirals PA</li>
                    <li>Process of giving VP</li>
                    <li>Annual Total CTC (fixed CTC + annual variable pay budget)</li>
                    <li>Increment on Fixed Annual CTC or Total Annual CTC</li>
                  </ul>
                </ion-col>
              </ion-row>

            </ion-col>
          </ion-row>
        </div>
      </div>
      <div class="modal-body" *ngIf="moduleName == 'importDWM'">
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
              <div class="importCardBox">
                <button class="downloadImportFileBtn font_medium mr-30 mt-10" [style.background-color]="buttonColorName " (click)="downloadImportFile()">
                  <img class="mr-10" src="././assets/icon/downloadWhite.svg">Download Import File Template</button>
                <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp"
                  (click)="browseImage.click()">
                  <div class="d-flex text-center">
                    <label class="uploadBtn text_center font_regular cp">Browse File<br>Please select Excel File
                      Only</label>
                    <input #browseImage type="file" (change)="selectImportDWMFile($event)" style="display:none;">
                  </div>
                </div>
                <div *ngIf="showBrowseBtn">
                  <div class="d-flex mb-50 mt-50">
                    <div class="verticle-center mr-20">
                      <img src="././assets/icon/successImport.svg">
                    </div>
                    <div class="flex-column">
                      <label class="fs-16 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                      <p class="fs-16 font_medium cl-black break-all">{{fileName}}</p>
                    </div>
                  </div>
                  <!-- <div class="mb-20"> -->
                    <!-- <button class="cancle-btn font_medium mr-10 mt-10" (click)="onClickCancel()">Cancel</button> -->
                    <!-- <button class="Donebtn font_medium mr-30 mt-10" (click)="onClickDone()">Done</button> -->
                  <!-- </div> -->
                </div>
              </div>
              <div class="clear20"></div>
              <label class="font_medium fs-16 cp blue" (click)="importHistory()"><u>Import
                  History</u></label>
            </ion-col>
          </ion-row>
        </div>
      </div>
      <div class="modal-body" *ngIf="moduleName == 'importgoals'">
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="12" size-md="9" size-lg="9" size-xs="12">
              <div class="importCardBox">
                <div class="p-5 fs-15 font_semibold">Step 1: Download Import Goals templete</div>
                <ion-row>
                  <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
                    <ng-select [clearable]="false" placeholder="Select" [(ngModel)]="selectedYear"
                      (change)="chnageSelectYear()" class="w-100">
                      <ng-option [value]="item.year"
                        *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                    </ng-select>
                  </ion-col>
                  <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
                    <ng-select [clearable]="false" placeholder="Select" [(ngModel)]="fromDate">
                      <ng-option [value]="item" class="w-100"
                        *ngFor="let item of getMonthsByFiscalandReviewCycle">{{sharedService.transform(item)}}</ng-option>
                    </ng-select>
                  </ion-col>

                  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                    <button [style.background-color]="buttonColorName" class="downloadImportFileBtn font_medium"
                      (click)="downloadAllPreviousKpis()">
                      <img class="mr-10" src="././assets/icon/downloadWhite.svg">Download Import File Template</button>
                  </ion-col>
                </ion-row>
              </div>
              <div class="importCardBox mt-20">
                <div class="p-5 fs-15 font_semibold">Step 2: Upload Import Goals</div>
                <div *ngIf="!showBrowseBtn" class="w-50 upload-box display-center ml-5 pt-25 pb-25 mt-10 mb-20 cp"
                  (click)="browseImage.click()">
                  <div class="d-flex text-center">
                    <label class="uploadBtn text_center font_regular cp">Browse File<br>Please select Excel File
                      Only</label>
                    <input #browseImage type="file" (change)="importFilesOfGoals($event)" style="display:none;">
                  </div>
                </div>
                <div *ngIf="showBrowseBtn">
                  <div class="d-flex mb-50 mt-20">
                    <div class="verticle-center mr-20">
                      <img src="././assets/icon/successImport.svg">
                    </div>
                    <div class="flex-column">
                      <label class="fs-16 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                      <div class="d-flex">
                        <label class="fs-16 font_medium cl-black">{{fileName}}</label>
                        <img src="././assets/icon/remove.png" class="removeIcon cp" (click)="onRemoveImportGoalsFile()">
                      </div>
                    </div>
                  </div>
                </div>
                <ion-row>
                  <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
                    <ng-select [clearable]="false" placeholder="Select" [(ngModel)]="selectedYear"
                      (change)="chnageSelectYear()" class="w-100">
                      <ng-option [value]="item.year"
                        *ngFor="let item of pmsYears">{{sharedService.transformYearToFyFormat(item.year)}}</ng-option>
                    </ng-select>
                  </ion-col>
                  <ion-col size-sm="6" size-md="3" size-lg="3" size-xs="6">
                    <ng-multiselect-dropdown class="mr-5 d-flex w-100" [placeholder]="'Select Months'"
                      [settings]="dropdownSettings" [data]="getMonthsByFiscalandReviewCycleForReport"
                      [(ngModel)]="selectedMoths" (onSelectAll)="selectAllMonths($event)"
                      (onDeSelectAll)="onDeSelectAllMonths()"></ng-multiselect-dropdown>
                  </ion-col>

                  <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
                    <button [style.background-color]="buttonColorName" class="downloadImportFileBtn font_medium"
                      (click)="onClickUploadGoals()">
                      <span class="material-icons fs-20 mr-5">arrow_upward</span>Upload Goals</button>
                  </ion-col>

                </ion-row>
              </div>
            </ion-col>
            <ion-col size-sm="12" size-md="3" size-lg="3" size-xs="12">
              <div class="font_regular fs-16 ml-10 mt-5 black_color">
                Note: While importing please make sure the following mandatory fields with data are present in the file
                (as per sample template available)
              </div>
              <ion-row>
                <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
                  <ul class="pl-30 font_regular fs-14">
                    <li>Employee ID</li>
                    <li>KRA</li>
                    <li>My KPI</li>
                    <li>Lesser is Better?</li>
                    <li>UOM</li>
                    <li>Weightage</li>
                    <li>Target</li>
                  </ul>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </div>
      </div>


      <!-- competency Import Section -->
      <div class="modal-body" *ngIf="moduleName === 'competencyImport'">
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="12">
              <div class="importCardBox">
                <button [style.background-color]="buttonColorName" (click)="downloadCompetencyImportFile()" class="downloadImportFileBtn font_medium mr-30 mt-10">
                  <img class="mr-10" src="././assets/icon/downloadWhite.svg">Download Import File Template
                </button>
                <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp">
                  <div class="d-flex text-center">
                    <label class="uploadBtn text_center font_regular cp" (click)="browseImage.click()">Browse File<br>Please select Excel File Only</label>
                    <input #browseImage type="file" (change)="selectCompetencyFile($event)" style="display:none;">
                    <!-- Trigger file input -->
                    <button (click)="browseImage.click()"></button>
                  </div>
                </div>
                <div *ngIf="showBrowseBtn">
                  <div class="d-flex mb-50 mt-50">
                    <div class="verticle-center mr-20">
                      <img src="././assets/icon/successImport.svg">
                    </div>
                    <div class="flex-column">
                      <label class="fs-16 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                      <label class="fs-16 font_medium cl-black">{{ selectedFileName }}</label>
                    </div>
                  </div>
                  <div class="mb-20">
                    <button class="Donebtn font_medium mr-30 mt-10" (click)="uploadCompetencyFile()">Done</button>
                  </div>
                </div>
              </div>
              
              <!-- Import History Text -->
              <div class="importHistory mt-10">
                <label class="font_medium fs-16 cp blue" (click)="importHistoryCompetency()"><u>Import
                  History</u></label>
              </div>
            </ion-col>
      
            <!-- Note Section -->
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="12">
              <div class="note-section">
                <label class="fs-14 font_regular text-danger">Note:</label>
                <p class="fs-14 font_regular text_gray1">
                  Please make sure the following mandatory fields with data are present in the file (as per sample template available above).
                </p>
                <ul class="fs-14 font_regular text_gray1 pl-3 ml-15">
                  <li>Function: Ensure the function field is correctly filled.</li>
                  <li>Band/Grade: Verify that the band or grade information is accurate.</li>
                  <li>Competency Name: The competency name must be clearly stated.</li>
                </ul>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
      
      <!-- <div class="modal-body" *ngIf="moduleName === 'positionrequisition'">
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="12">
              <div class="importCardBox">
                <button [style.background-color]="buttonColorName" (click)="downloadPositionRequisitionTemplate()" class="downloadImportFileBtn font_medium mr-30 mt-10">
                  <img class="mr-10" src="././assets/icon/downloadWhite.svg">Download Import File Template
                </button>
      
                <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp">
                  <div class="d-flex text-center">
                    <label class="uploadBtn text_center font_regular cp" (click)="browseFile.click()">Browse File<br>Please select Excel File Only</label>
                    <input #browseFile type="file" (change)="selectPositionRequisitionFile($event)" style="display:none;" />
                  </div>
                </div>
      
                <div *ngIf="showBrowseBtn">
                  <div class="d-flex mb-50 mt-50">
                    <div class="verticle-center mr-20">
                      <img src="././assets/icon/successImport.svg">
                    </div>
                    <div class="flex-column">
                      <label class="fs-16 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                      <label class="fs-16 font_medium cl-black">{{ selectedPositionRequisitionFileName }}</label>
                    </div>
                  </div>
                  <div class="mb-20">
                    <button class="Donebtn font_medium mr-30 mt-10" (click)="uploadPositionRequisitionFile()">Done</button>
                  </div>
                </div>
              </div>
      
              <div class="importHistory mt-10">
                <label class="font_medium fs-16 cp blue" (click)="importHistory()"><u>Import History</u></label>
              </div>
            </ion-col>
      
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="12">
              <div class="note-section">
                <label class="fs-14 font_regular text-danger">Note:</label>
                <p class="fs-14 font_regular text_gray1">
                  Please make sure the following mandatory fields are present in the file (as per template).
                </p>
                <ul class="fs-14 font_regular text_gray1 pl-3 ml-15">
                  <li>Position Name</li>
                  <li>Designation</li>
                  <li>Band</li>
                  <li>Department</li>
                  <li>Location</li>
                  <li>Panel Members</li>
                </ul>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div> -->
      
      <div class="modal-body" *ngIf="moduleName === 'candidateImport'">
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="12">
              <div class="importCardBox">
                <button [style.background-color]="buttonColorName" (click)="downloadCandidateTemplate()" class="downloadImportFileBtn font_medium mr-30 mt-10">
                  <img class="mr-10" src="././assets/icon/downloadWhite.svg" />Download Import File Template
                </button>
      
                <div *ngIf="!showBrowseBtn" class="w-100 upload-box display-center pt-25 pb-25 mt-20 cp">
                  <div class="d-flex text-center">
                    <label class="uploadBtn text_center font_regular cp" (click)="browseCandidateFile.click()">Browse File<br>Please select Excel File Only</label>
                    <input #browseCandidateFile type="file" (change)="selectCandidateFile($event)" style="display:none;" />
                  </div>
                </div>
      
                <div *ngIf="showBrowseBtn">
                  <div class="d-flex mb-50 mt-50">
                    <div class="verticle-center mr-20">
                      <img src="././assets/icon/successImport.svg" />
                    </div>
                    <div class="flex-column">
                      <label class="fs-16 font_medium text_gray1 mb-10">File Uploaded Successfully.</label>
                      <label class="fs-16 font_medium cl-black">{{ selectedCandidateFileName }}</label>
                    </div>
                  </div>
                  <div class="mb-20">
                    <button class="Donebtn font_medium mr-30 mt-10" (click)="uploadCandidateFile()">Done</button>
                  </div>
                </div>
              </div>
      
              <div class="importHistory mt-10">
                <label class="font_medium fs-16 cp blue" (click)="importHistory()"><u>Import History</u></label>
              </div>
            </ion-col>
      
            <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="12">
              <div class="note-section">
                <label class="fs-14 font_regular text-danger">Note:</label>
                <p class="fs-14 font_regular text_gray1">
                  Please ensure the following fields are present in the file:
                </p>
                <ul class="fs-14 font_regular text_gray1 pl-3 ml-15">
                  <li>Candidate Name</li>
                  <li>Email</li>
                  <li>Phone</li>
                  <li>Position Applied For</li>
                  <li>Application Date</li>
                  <li>Skills</li>
                </ul>
              </div>
            </ion-col>
          </ion-row>
        </div>
      </div>
      
    </div>
  </div>
</ion-content>